import { DeleteOutlined, DownloadOutlined, FilePdfOutlined } from '@ant-design/icons';
import { useDocumentSasUrl } from '@hooks';
import { L } from '@lib';
import { DocumentDto } from '@services';
import { useStore } from '@stores';
import { Utils } from '@utils';
import { Button, Col, Image, Modal, Row, Typography } from 'antd';
import { observer } from 'mobx-react';
import React, { useCallback, useState } from 'react';
import { VideoPreview } from './VideoPreview';

const { Text } = Typography;
interface IServiceOrderDocumentProps {
  document?: DocumentDto;
  hideDelete?: boolean;
  imageWidth?: number;
  imageHeight?: number;
  fontSize?: number;
  handleDocumentDelete?: (id: string) => void;
}

export const DocumentShared: React.FC<IServiceOrderDocumentProps> = observer(
  ({ document, hideDelete = false, imageWidth = 64, imageHeight = 64, fontSize = 64, handleDocumentDelete }) => {
    const { documentStore } = useStore();
    const [showModal, setShowModal] = useState(false);

    const queryString = useDocumentSasUrl();
    const afterQuestionMark = queryString.split('?')[1];

    const handleDocumentDownload = useCallback(
      async (id: string) =>
        await documentStore.get({ id }).then((response) => Utils.documentDownload(response)),
      [documentStore]
    );

    const handleDeleteDocument = (id: string) => {
      setShowModal(!showModal);
      handleDocumentDelete!(id);
    };

    const handleDeleteCancel = () => {
      setShowModal(false);
    };

    return (
      <>
        <Row justify="space-between" align="middle">
          <Col>
            <Row gutter={16} align="middle" style={{ marginBottom: 8 }}>
              <Col>
                {document?.type.toLowerCase().includes('image') ? (
                  <Image
                    src={`${document?.url}?${afterQuestionMark}`}
                    alt={document?.name}
                    style={{ width: imageWidth, height: imageHeight }}
                  />
                ) : document?.type.toLowerCase().includes('video') ? (
                  <VideoPreview url={`${document?.url}?${afterQuestionMark}`} />
                ) : (
                  <FilePdfOutlined style={{ fontSize: fontSize }} />
                )}
              </Col>
              <Col>
                <Text>{document?.name}</Text>
              </Col>
            </Row>
          </Col>
          <Col>
            <DownloadOutlined onClick={() => document && handleDocumentDownload(document.id)} />
            {!hideDelete && (
              <Button
                type="text"
                onClick={() => setShowModal(true)}
                icon={<DeleteOutlined />}
              ></Button>
            )}
          </Col>
        </Row>
        <Modal
          title={L('Are you sure you want to delete this document: ')}
          open={showModal}
          onOk={() => handleDeleteDocument(document!.id)}
          onCancel={handleDeleteCancel}
        >
          {document?.name}
        </Modal>
      </>
    );
  }
);
